import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import axios from "axios";
import {
    FaChevronDown, FaChevronUp, FaPlus, FaTrash, FaShieldAlt
} from "react-icons/fa";
import styles from "./SifatSiyosati.module.css";
import { testUrl } from "../home/BaseData";

const SifatSiyosati = () => {
    const { t, i18n } = useTranslation();
    const [activeIndex, setActiveIndex] = useState(null);
    const [policyData, setPolicyData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [clickCount, setClickCount] = useState(0);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);

    const initialData = [
        {
            title: "Umumiy qoidalar",
            content: `1.1. Renessans taʼlim universitetining ichki taʼlim sifatini taʼminlash tizimi taʼlim sifatini oshirish va sifatni yaxshilash madaniyatini rivojlantirish uchun Universitetda tashkil etilgan umumiy yondashuvlar, siyosatlar, asosiy tamoyillar, standartlar va asosiy mexanizmlarni aks ettiradi.\n\n1.2. Universitet ichki taʼlim sifatini taʼminlash tizimi strategik menejmentning ajralmas qismi boʻlib, boshqa hujjatlar, masalan, Universitetning rivojlanish konsepsiyasi, strategiyasi, akademik siyosati bilan birgalikda koʻrib chiqiladi.`
        },
        {
            title: "Sifatni taʼminlash tamoyillari",
            content: `2.1. Universitetda ichki taʼlim sifatini taʼminlashнинг asosiy tamoyili doimiy rivojlanish hisoblanadi.\n\n2.2. Universitetda ichki taʼlim sifatini taʼminlash tizimi sifatni taʼminlashнинг quyidagi asosiy tamoyillarini belgilaydi:\n- Sifat kafolati oliy taʼlim bosqichlari va talabalarning xilma-xilligiga mos keladi;\n- Universitet faoliyatining Qonunchilik va meyoriy talablarga, xalqaro tavsiyalarga muvofiqligi;\n- Sifatning taʼminlanishi va oshirib burilishi barcha taʼlim dasturlari uchun qoʻllaniladi.`
        },
        {
            title: "Sifatni taʼminlash uchun javobgarlik",
            content: `3.1. Taʼlim sifatini taʼminlash universitet rahbariyati, barcha tarkibiy boʻlinmalar, xodimlar va taʼlim oluvchilarning umumiy javobgarligi hisoblanadi.\n\n3.2. Ichki sifatni taʼminlash tizimi siyosati va standartlari rektor tomonidan tasdiqlanadi.`
        }
    ];

    const fetchData = async () => {
        try {
            setLoading(true);
            const response = await axios.get(`${testUrl}/api/quality-policy/`);

            if (response.data && response.data.length > 0) {
                const lang = i18n.language; // 'uz', 'ru', 'en'
                const mappedData = response.data.map(item => ({
                    title: item[`title_${lang}`] || item.title_uz,
                    content: item[`content_${lang}`] || item.content_uz
                }));
                setPolicyData(mappedData);
            } else {
                setPolicyData(initialData);
            }
        } catch (error) {
            console.error("Error fetching quality policy:", error);
            setPolicyData(initialData);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, [i18n.language]);

    const toggleAccordion = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    const handleSecretClick = () => {
        setClickCount(prev => {
            const newCount = prev + 1;
            if (newCount === 5) {
                setIsEditModalOpen(true);
                return 0;
            }
            return newCount;
        });
        setTimeout(() => setClickCount(0), 3000);
    };

    const handleSave = async () => {
        try {
            // Save to global DB via bulk-sync
            await axios.post(`${testUrl}/api/quality-policy/bulk-sync/`, policyData);
            setIsEditModalOpen(false);
            alert("Ma'lumotlar global miqyosda saqlandi!");
            // Refresh local data
            fetchData();
        } catch (error) {
            console.error("Error saving quality policy:", error);
            alert("Xatolik yuz berdi. Iltimos qaytadan urunib ko'ring.");
        }
    };

    const addNewSection = () => {
        setPolicyData([...policyData, { title: "Yangi bo'lim", content: "" }]);
    };

    const deleteSection = (index) => {
        if (window.confirm("Haqiqatan ham ushbu bo'limni o'chirib tashlamoqchimisiz?")) {
            const newData = policyData.filter((_, i) => i !== index);
            setPolicyData(newData);
        }
    };

    const updateSection = (index, field, value) => {
        const newData = [...policyData];
        newData[index][field] = value;
        setPolicyData(newData);
    };

    if (loading) {
        return <div className={styles.loading}>{t("loading") || "Yuklanmoqda..."}</div>;
    }

    return (
        <div className={styles.mainContainer}>
            <div className={styles.container}>
                <h1 className={styles.mainTitle} data-aos="fade-up">
                    Universitetning ichki taʼlim sifatini <br /> taʼminlash siyosati
                </h1>

                <div className={styles.introBox} data-aos="fade-up">
                    <p>Renessans Ta'lim Universiteti ta'lim sifatini doimiy ravishda oshirib borish, xalqaro standartlarga muvofiqlikni ta'minlash va talabalarga yo'naltirilgan ta'lim muhitini yaratishga intiladi. Quyida universitetning sifatni ta'minlash tizimining asosiy yo'nalishlari va tamoyillari keltirilgan.</p>
                </div>

                <div className={styles.accordionContainer} data-aos="fade-up">
                    {policyData.map((item, index) => (
                        <div key={index} className={`${styles.accordionItem} ${activeIndex === index ? styles.active : ""}`}>
                            <button className={styles.accordionHeader} onClick={() => toggleAccordion(index)}>
                                <div className={styles.headerTitle}>
                                    <span
                                        className={styles.icon}
                                        style={{ cursor: 'pointer' }}
                                        onClick={(e) => {
                                            if (index === 0) {
                                                e.stopPropagation();
                                                handleSecretClick();
                                            }
                                        }}
                                    >
                                        <FaShieldAlt />
                                    </span>
                                    <h2>{item.title}</h2>
                                </div>
                                <div className={styles.headerAction}>
                                    <span className={styles.seeMoreTxt}>{activeIndex === index ? "Yopish" : "Ko'proq ko'rish"}</span>
                                    {activeIndex === index ? <FaChevronUp /> : <FaChevronDown />}
                                </div>
                            </button>
                            <div className={styles.accordionContent}>
                                <div className={styles.innerContent}>
                                    {item.content && item.content.split('\n').map((line, i) => (
                                        <p key={i}>{line}</p>
                                    ))}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Admin Edit Modal */}
            {isEditModalOpen && (
                <div className={styles.modalOverlay}>
                    <div className={styles.modalContent}>
                        <div className={styles.modalHeader}>
                            <h2>Siyosatni tahrirlash</h2>
                            <button className={styles.closeBtn} onClick={() => setIsEditModalOpen(false)}>&times;</button>
                        </div>

                        <div className={styles.formList}>
                            {policyData.map((item, index) => (
                                <div key={index} className={styles.formItem}>
                                    <div className={styles.inputGroup}>
                                        <label>Sarlavha</label>
                                        <input
                                            className={styles.inputField}
                                            value={item.title}
                                            onChange={(e) => updateSection(index, 'title', e.target.value)}
                                        />
                                    </div>
                                    <div className={styles.inputGroup}>
                                        <label>Mazmun (Har bir yangi qator abzats bo'ladi)</label>
                                        <textarea
                                            className={styles.textareaField}
                                            value={item.content}
                                            onChange={(e) => updateSection(index, 'content', e.target.value)}
                                        />
                                    </div>
                                    <div className={styles.itemActions}>
                                        <button className={styles.deleteBtn} onClick={() => deleteSection(index)}>
                                            <FaTrash style={{ marginRight: '5px' }} /> O'chirish
                                        </button>
                                    </div>
                                </div>
                            ))}
                        </div>

                        <button className={styles.addBtn} onClick={addNewSection}>
                            <FaPlus /> Yangi bo'lim qo'shish
                        </button>

                        <div className={styles.footerActions}>
                            <button className={styles.saveBtn} onClick={handleSave}>O'zgarishlarni saqlash</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default SifatSiyosati;
